import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import { OriginatorBankFieldValidation } from "../../types/aba";

interface ValidationResult {
  isValid: boolean; 
  error?: string; 
  formatted?: string;
  institutionName?: string;
}

interface ValidationMessageProps {
  /** Validation state for a specific field */
  validation?: OriginatorBankFieldValidation | ValidationResult;
  /** Show validation message even when valid (for success states) */
  showWhenValid?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Component to display field validation messages
 * Shows error messages for invalid fields and optionally success messages for valid fields
 */
const ValidationMessage: React.FunctionComponent<ValidationMessageProps> = ({
  validation,
  showWhenValid = false,
  className = "",
}) => {
  if (!validation) return null;

  // Show error message if invalid
  if (!validation.isValid && validation.error) {
    return (
      <div className={`text-danger small mt-1 ${className}`}>
        <FontAwesomeIcon icon={faExclamationCircle} className="me-1" />
        {validation.error}
      </div>
    );
  }

  // Show success message if valid and requested
  if (validation.isValid && showWhenValid) {
    const hasValidation = validation as ValidationResult;
    
    return (
      <div className={`text-success small mt-1 ${className}`}>
        <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
        {hasValidation.institutionName && (
          <span className="fw-bold me-2">{hasValidation.institutionName}</span>
        )}
        {hasValidation.formatted && (
          <span>({hasValidation.formatted})</span>
        )}
        {!hasValidation.institutionName && !hasValidation.formatted && "Valid"}
      </div>
    );
  }

  return null;
};

export default ValidationMessage;
